// Mock data for CoreDesk website
export const NAV_ITEMS = [
  {
    label: 'Produtos',
    to: '/produtos',
    children: [
      { label: 'Atendimento e Chatbot', desc: 'Centralize conversas em uma tela', to: '/produtos#conversas' },
      { label: 'Central de Suporte', desc: 'Helpdesk com gestão de tickets', to: '/produtos#helpdesk' },
      { label: 'Agentes de IA (CoreAI)', desc: 'Automação inteligente 24/7', to: '/produtos#coreai' },
      { label: 'Integrações', desc: 'Conecte com o seu stack', to: '/integracoes' },
    ],
  },
  {
    label: 'Soluções',
    to: '/solucoes',
    children: [
      { label: 'Varejo e E-commerce', desc: 'Vendas conversacionais', to: '/solucoes#varejo' },
      { label: 'Educação', desc: 'Atendimento em picos', to: '/solucoes#educacao' },
      { label: 'Saúde e Clínicas', desc: 'Recepção inteligente', to: '/solucoes#saude' },
      { label: 'B2B e Serviços', desc: 'Suporte de excelência', to: '/solucoes#b2b' },
    ],
  },
  { label: 'Preços', to: '/precos' },
  { label: 'Integrações', to: '/integracoes' },
  {
    label: 'Recursos',
    to: '/blog',
    children: [
      { label: 'Blog', desc: 'Insights de atendimento e IA', to: '/blog' },
      { label: 'Central de Ajuda', desc: 'Tutoriais e documentação', to: '/ajuda' },
      { label: 'Calculadora de ROI', desc: 'Descubra seu retorno em minutos', to: '/calculadora-roi' },
      { label: 'API & Desenvolvedores', desc: 'Documentação técnica', to: '/desenvolvedores' },
    ],
  },
  { label: 'Sobre', to: '/sobre' },
];

// Trust pillars replacing fake client count
export const TRUST_PILLARS = [
  {
    icon: 'MessagesSquare',
    title: 'Multiatendimento no WhatsApp',
    desc: 'Vários atendentes atuando no mesmo número, com histórico único por cliente e roteamento inteligente por perfil.',
  },
  {
    icon: 'Lock',
    title: '100% LGPD & Seguro',
    desc: 'Criptografia ponta a ponta, servidores no Brasil e conformidade total com a LGPD desde o dia um.',
  },
  {
    icon: 'Rocket',
    title: 'Setup em 48 horas',
    desc: 'Time dedicado de implantação para colocar sua operação no ar rapidamente e sem dor de cabeça.',
  },
  {
    icon: 'HeadphonesIcon',
    title: 'Suporte humano no Brasil',
    desc: 'Fale com pessoas de verdade, em português, quando precisar. Chat, e-mail e WhatsApp.',
  },
];

export const COMMITMENTS = [
  { k: '99.9%', v: 'SLA de uptime da plataforma' },
  { k: '< 30s', v: 'Tempo médio de primeira resposta com CoreAI' },
  { k: '14 dias', v: 'Trial gratuito sem cartão de crédito' },
  { k: '24/7', v: 'Monitoramento e infraestrutura ativos' },
];

export const PRODUCTS = [
  {
    id: 'conversas',
    tag: 'CoreDesk Conversas',
    title: 'Acabe com a lentidão no atendimento ao cliente',
    description:
      'Todos os seus canais em uma única tela. WhatsApp, Instagram, Messenger, e-mail e chat. Atribua atendimentos, responda e crie automações.',
    bullets: [
      'Multiatendimento no WhatsApp (mesmo número, vários agentes)',
      'Chatbot e automação com IA (CoreAI Agente)',
      'Caixa de entrada unificada com histórico do cliente',
      'Disparos em massa com segmentação de contatos',
      'Relatórios de tempo de resposta, SLA e volume por canal',
    ],
  },
  {
    id: 'helpdesk',
    tag: 'Helpdesk',
    title: 'Resolva mais chamados em menos tempo',
    description:
      'Gestão de tickets com SLA, filas de prioridade e automações. O controle que sua operação precisa para não deixar nenhum cliente esperando.',
    bullets: [
      'Abertura de tickets por e-mail, formulário e chat',
      'SLA configurável por grupo e tipo de demanda',
      'Roleta de distribuição eficiente de tickets',
      'Automações, gatilhos e workflows sem código',
      'Pesquisa de satisfação integrada ao ticket',
    ],
  },
  {
    id: 'coreai',
    tag: 'CoreAI',
    title: 'Agente de Inteligência Artificial',
    description:
      'Atendimento autônomo que guia sua equipe com as melhores respostas e executa tarefas de forma automática dentro da plataforma.',
    bullets: [
      'Atendimento autônomo por IA generativa, 24/7',
      'Sugestão de respostas em tempo real para agentes humanos',
      'Transcrição automática de áudios em texto',
      'Integração com sistemas externos via tarefas automatizadas',
      'Identifica lacunas e melhora as respostas continuamente',
    ],
  },
];

export const SEGMENTS = [
  { id: 'varejo', icon: 'ShoppingCart', title: 'Varejo e E-commerce', lead: 'Seu cliente teve uma dúvida às 22h. O concorrente já respondeu.', body: 'O CoreAI responde em segundos usando os materiais do seu e-commerce. Seu cliente não fica sem resposta, em nenhum horário.', highlight: 'Nenhuma dúvida sem resposta, mesmo fora do horário comercial.' },
  { id: 'educacao', icon: 'GraduationCap', title: 'Educação', lead: 'Atenda o pico de matrículas sem aumentar o time.', body: 'No período de matrículas o volume explode. O CoreAI resolve as dúvidas repetidas automaticamente e aciona o humano só quando importa.', highlight: 'Atendimentos no momento certo, sem sobrecarregar sua equipe.' },
  { id: 'saude', icon: 'Stethoscope', title: 'Saúde e Clínicas', lead: 'Elimine áudios não ouvidos e preencha a agenda da sua clínica.', body: 'Sabe aquele áudio de 3 minutos do paciente? O CoreAI transcreve e resume a dúvida instantaneamente. Sua recepção entende em segundos.', highlight: 'Reduza o tempo de espera no WhatsApp e acabe com os áudios não ouvidos.' },
  { id: 'b2b', icon: 'Building2', title: 'B2B e Serviços', lead: 'Resolução no primeiro contato para um suporte de excelência.', body: 'O CoreAI Copiloto consulta seus manuais e sugere a resposta exata. Até o atendente mais novo guia o cliente como um verdadeiro especialista.', highlight: 'Aumento na taxa de FCR e queda nos escalonamentos.' },
];

export const FEATURED_INTEGRATIONS = [
  { name: 'WhatsApp', category: 'Mensageria', color: '#25D366', letter: 'W', desc: 'Multiatendimento no mesmo número, com histórico único por cliente, chatbot, disparos segmentados e roteamento inteligente entre agentes.' },
  { name: 'Instagram', category: 'Redes Sociais', color: '#E1306C', letter: 'I', desc: 'Responda mensagens diretas, comentários e menções do Instagram direto na inbox unificada da CoreDesk.' },
  { name: 'Facebook', category: 'Redes Sociais', color: '#1877F2', letter: 'F', desc: 'Centralize Facebook Messenger, comentários de páginas e anúncios em uma única tela com histórico completo por contato.' },
  { name: 'E-mail (IMAP/SMTP)', category: 'Canal de e-mail', color: '#EA4335', letter: '@', desc: 'Conecte qualquer caixa de e-mail via IMAP e envie via SMTP. Transforme respostas em tickets automaticamente e centralize tudo em uma inbox.' },
  { name: 'Chat do site (Widget)', category: 'Canal Web', color: '#FF5B24', letter: 'C', desc: 'Widget de chat personalizável para o seu site. Instale em minutos e capture leads 24/7 com atendimento humano ou pelo CoreAI.' },
  { name: 'Telegram', category: 'Mensageria', color: '#229ED9', letter: 'T', desc: 'Atenda seus clientes no Telegram com bots, grupos e canais totalmente integrados à CoreDesk, com histórico único por contato.' },
  { name: 'TikTok', category: 'Redes Sociais', color: '#111111', letter: 'T', desc: 'Responda comentários e mensagens diretas do TikTok direto da sua caixa de entrada CoreDesk, sem precisar sair da plataforma.' },
  { name: 'X (Twitter)', category: 'Redes Sociais', color: '#000000', letter: 'X', desc: 'Monitore menções, responda DMs e converta interações do X em tickets rastreáveis com SLA e histórico completo.' },
];

export const FAQS = [
  { q: 'O que é CoreDesk?', a: 'CoreDesk é uma plataforma de atendimento completa, do marketing ao pós-vendas. Centralize conversas e chamados, priorize e automatize demandas com três produtos: CoreDesk Conversas, Helpdesk e CoreAI, nossa inteligência artificial.' },
  { q: 'O que é CoreDesk Conversas?', a: 'É a plataforma de chat-commerce que centraliza todo o atendimento da sua empresa. Conecte WhatsApp, Instagram Direct, Facebook Messenger e chat no site em uma única tela, com múltiplos agentes atuando no mesmo número.' },
  { q: 'O que é o Helpdesk da CoreDesk?', a: 'É a plataforma que centraliza todos os canais de suporte (e-mail, chat, central de ajuda e WhatsApp) em um único lugar, transformando cada solicitação em um ticket. Cria um histórico único por cliente para resoluções rápidas.' },
  { q: 'O que é o CoreAI?', a: 'O CoreAI é a Inteligência Artificial Generativa da CoreDesk. Ele entende linguagem natural, interpreta áudios e busca respostas na sua base de conhecimento. Atua 24/7 acelerando Vendas e resolvendo tickets autonomamente.' },
  { q: 'A CoreDesk se integra aos sistemas da empresa?', a: 'Sim. A CoreDesk conecta múltiplos canais (WhatsApp, Instagram, Facebook, Telegram, TikTok, X, E-mail IMAP/SMTP, Chat do site, SMS, Voz e API personalizada), ferramentas de produtividade (Slack, Linear), CRM (LeadSquared) e IA/Linguagem (Dialogflow, Google Translate, Cloudflare RealtimeKit). Além disso, oferecemos API aberta e webhooks para integrações customizadas.' },
  { q: 'Existe período de teste gratuito?', a: 'Sim! Oferecemos 14 dias de trial gratuito em todos os planos, sem cobrança de cartão de crédito na inscrição.' },
  { q: 'Onde comprar créditos para utilizar a IA?', a: 'Os créditos utilizados pela Inteligência Artificial são adquiridos diretamente na plataforma da OpenAI.\n\nCaso ainda não possua uma conta, basta criar seu cadastro e adicionar créditos para começar a utilizar os recursos de IA em nossa plataforma.\n\nVocê pode acessar a plataforma oficial da OpenAI pelo seguinte endereço: https://platform.openai.com/\n\nSe precisar de ajuda durante o processo, consulte nosso guia passo a passo, onde explicamos como criar sua conta, adicionar créditos e obter a chave de API necessária para integrar a IA ao sistema.' },
];

export const PRICING = [
  { name: 'Starter', price: '1280', period: 'por 1 usuário / mês', description: 'Para autônomos e times enxutos que querem organizar o atendimento.',
    features: ['WhatsApp multiatendimento', 'Até 3 canais integrados', 'Chatbot com fluxos visuais', 'Relatórios essenciais', 'Suporte por chat'], highlighted: false },
  { name: 'Business', price: '1850', period: 'por 3 usuários / mês', description: 'Para operações que precisam escalar com automação.',
    features: ['Tudo do Starter', 'Canais ilimitados', 'CoreAI Copiloto', 'Automações e workflows', 'SLA e roleta de tickets', 'API e integrações'], highlighted: true },
  { name: 'Enterprise', price: 'Custom', period: 'sob consulta', description: 'Para grandes empresas com necessidades avançadas.',
    features: ['Tudo do Business', 'CoreAI Autônomo dedicado', 'SSO e permissões avançadas', 'Ambiente dedicado', 'Success Manager exclusivo', 'SLA garantido em contrato'], highlighted: false },
];

// Campaign message credits (add-on for bulk messaging)
export const CAMPAIGN_CREDITS = [
  { credits: '1.000', price: '159,90', costPerMessage: '0,16', popular: false },
  { credits: '2.000', price: '249,90', costPerMessage: '0,12', popular: true, badge: 'Melhor custo/benefício' },
  { credits: '5.000', price: '489,90', costPerMessage: '0,10', popular: false },
  { credits: '7.500', price: '689,90', costPerMessage: '0,09', popular: false },
];

export const CAMPAIGN_INFO = [
  { type: 'info', text: 'Os créditos são consumidos apenas em conexões realizadas via Código QR.' },
  { type: 'info', text: 'Campanhas enviadas utilizando a API Oficial do WhatsApp não consomem créditos de campanha.' },
  { type: 'warning', text: 'O envio de mensagens em massa utilizando conexões por Código QR pode aumentar o risco de restrições pelo WhatsApp.' },
  { type: 'success', text: 'Para maior estabilidade, segurança e menor risco de restrições, recomendamos utilizar a API Oficial do WhatsApp para campanhas de envio em massa.' },
];

export const VALUES = [
  { icon: 'Target', title: 'Foco no cliente', desc: 'Cada linha de código e cada feature nasce ouvindo quem está na linha de frente do atendimento.' },
  { icon: 'Sparkles', title: 'IA com propósito', desc: 'IA não é modinha. Usamos onde ela realmente entrega valor ao cliente final e ao seu time.' },
  { icon: 'Users', title: 'Time no Brasil', desc: 'Falamos sua língua, entendemos sua realidade. Suporte, produto e engenharia no Brasil.' },
  { icon: 'Zap', title: 'Movimento rápido', desc: 'Somos uma startup e evoluímos rápido — seu feedback vira feature em semanas, não anos.' },
];

// Blog posts
export const BLOG_POSTS = [
  {
    id: 1,
    slug: 'como-agentes-de-ia-reduzem-custo-de-atendimento',
    category: 'IA',
    title: 'Como agentes de IA reduzem 70% do custo de atendimento',
    excerpt: 'Entenda como implementar IA generativa no seu atendimento sem perder qualidade e mantendo o toque humano onde importa.',
    author: 'Rafael Costa',
    date: '2 dias atrás',
    readTime: '6 min',
    gradient: 'from-[#FF5B24] to-[#ff8f5a]',
    content: [
      { type: 'p', text: 'Atender bem custa caro — e escalar esse atendimento sem estourar o orçamento é o desafio de quase toda operação em crescimento. A boa notícia: agentes de IA bem implementados resolvem a maior parte dos contatos repetitivos e liberam o time humano para o que realmente exige empatia e julgamento.' },
      { type: 'h2', text: 'Por que o custo por atendimento explode' },
      { type: 'p', text: 'A maior parte do custo de um SAC não está nos casos complexos, e sim no volume de perguntas simples e repetitivas: "cadê meu pedido?", "como troco meu plano?", "qual o horário de funcionamento?". Cada uma dessas ocupa um atendente por vários minutos — e, somadas, consomem a maior fatia da folha da operação.' },
      { type: 'h2', text: 'Onde a IA gera economia real' },
      { type: 'ul', items: [
        'Resolução autônoma 24/7 das dúvidas de baixa complexidade, sem fila e sem custo por hora.',
        'Triagem inteligente: a IA entende a intenção e já direciona para a pessoa ou o fluxo certo.',
        'Respostas sugeridas para os atendentes humanos, cortando o tempo médio de resposta pela metade.',
        'Resumo automático de conversas longas, eliminando o trabalho manual de anotação.',
      ] },
      { type: 'h2', text: 'O toque humano continua essencial' },
      { type: 'p', text: 'Reduzir custo não é substituir pessoas — é usá-las onde geram mais valor. Negociações, reclamações delicadas e vendas consultivas continuam humanas. A IA assume o repetitivo e entrega ao atendente o contexto completo, para que ele comece a conversa já sabendo do que se trata.' },
      { type: 'quote', text: 'A meta não é ter menos gente, é ter gente resolvendo o que máquina nenhuma resolve.' },
      { type: 'h2', text: 'Como começar sem riscos' },
      { type: 'ul', items: [
        'Escolha 3 a 5 dúvidas mais frequentes e ensine a IA a respondê-las com sua base de conhecimento.',
        'Mantenha o "handoff" para humano sempre a um clique de distância.',
        'Acompanhe taxa de resolução e CSAT semana a semana e expanda o escopo aos poucos.',
      ] },
      { type: 'p', text: 'Com o CoreAI, esse ciclo roda dentro da mesma plataforma de atendimento — sem integrações frágeis e sem perder o histórico do cliente. É assim que operações chegam a reduzir até 70% do custo por contato mantendo (e muitas vezes elevando) a satisfação.' },
    ],
  },
  {
    id: 2,
    slug: 'metricas-essenciais-operacao-de-suporte',
    category: 'Atendimento',
    title: '10 métricas essenciais para acompanhar em uma operação de suporte',
    excerpt: 'Do FCR ao CSAT: os KPIs que realmente importam para escalar seu time sem perder eficiência.',
    author: 'Marina Alves',
    date: '5 dias atrás',
    readTime: '8 min',
    gradient: 'from-indigo-500 to-purple-500',
    content: [
      { type: 'p', text: 'Você não melhora o que não mede. Mas medir tudo é tão ruim quanto não medir nada — o excesso de indicadores esconde o que importa. Estas são as 10 métricas que toda operação de suporte deveria acompanhar de perto.' },
      { type: 'h2', text: 'As métricas de experiência' },
      { type: 'ul', items: [
        'CSAT — satisfação do cliente logo após o atendimento.',
        'NPS — lealdade e propensão a recomendar sua marca.',
        'CES — o esforço que o cliente teve para resolver o problema.',
      ] },
      { type: 'h2', text: 'As métricas de eficiência' },
      { type: 'ul', items: [
        'FCR (First Contact Resolution) — % de casos resolvidos no primeiro contato.',
        'TMR — tempo médio de resposta ao cliente.',
        'TMA — tempo médio de atendimento até o encerramento.',
        'Backlog — tickets abertos aguardando resolução.',
      ] },
      { type: 'h2', text: 'As métricas de operação' },
      { type: 'ul', items: [
        'Volume por canal — onde seus clientes realmente estão.',
        'Taxa de reabertura — sinal claro de resolução mal feita.',
        'SLA de cumprimento — % de atendimentos dentro do prazo prometido.',
      ] },
      { type: 'quote', text: 'FCR alto e reabertura baixa quase sempre significam CSAT em alta. Comece por eles.' },
      { type: 'h2', text: 'Como transformar números em ação' },
      { type: 'p', text: 'Métrica sem rotina de revisão vira enfeite de dashboard. Defina uma meta para cada KPI, revise semanalmente com o time e conecte cada movimento a uma causa. No CoreDesk, todos esses indicadores ficam em tempo real no mesmo painel — por canal, por agente e por fila — para você agir antes que o problema vire crise.' },
    ],
  },
  {
    id: 3,
    slug: 'chat-commerce-vender-pelo-whatsapp',
    category: 'Vendas',
    title: 'Chat-commerce: por que sua loja precisa vender pelo WhatsApp em 2026',
    excerpt: 'O comportamento do consumidor mudou. Descubra como transformar conversas em vendas com automação.',
    author: 'Bruno Lima',
    date: '1 semana atrás',
    readTime: '5 min',
    gradient: 'from-emerald-500 to-teal-500',
    content: [
      { type: 'p', text: 'O brasileiro vive no WhatsApp — e é lá que ele quer descobrir produtos, tirar dúvidas e comprar. Chat-commerce é exatamente isso: vender dentro da conversa, sem forçar o cliente a migrar para um site que ele não conhece.' },
      { type: 'h2', text: 'A mudança no comportamento de compra' },
      { type: 'p', text: 'A jornada deixou de ser linear. O cliente vê um anúncio, chama no WhatsApp, some por dois dias e volta pronto para fechar. Quem estiver presente e organizado nessa conversa ganha a venda; quem responder em horas, perde.' },
      { type: 'h2', text: 'Como a automação aumenta a conversão' },
      { type: 'ul', items: [
        'Resposta imediata 24/7, mesmo fora do horário comercial, no momento de maior interesse.',
        'Qualificação automática do lead antes de chegar ao vendedor.',
        'Catálogo, link de pagamento e status do pedido dentro da própria conversa.',
        'Recuperação de carrinho e follow-up automático de quem sumiu.',
      ] },
      { type: 'quote', text: 'No chat-commerce, velocidade de resposta é preço. Quem responde primeiro fecha primeiro.' },
      { type: 'h2', text: 'O equilíbrio entre bot e vendedor' },
      { type: 'p', text: 'O segredo não é automatizar tudo, é automatizar o começo. A IA acolhe, entende e qualifica; o vendedor entra para a etapa consultiva e para o fechamento. Com o CoreDesk, essa passagem de bastão é fluida — o vendedor recebe a conversa com todo o contexto e continua de onde a IA parou.' },
      { type: 'p', text: 'Resultado: menos leads perdidos, ciclo de venda mais curto e um WhatsApp que deixa de ser bagunça para virar canal de receita previsível.' },
    ],
  },
  {
    id: 4,
    slug: 'guia-configurar-sla-sem-estresse',
    category: 'Guias',
    title: 'Guia definitivo: como configurar SLA sem gerar estresse no time',
    excerpt: 'Metodologia passo a passo para definir metas de SLA realistas e implementar sem quebrar sua operação.',
    author: 'Rafael Costa',
    date: '2 semanas atrás',
    readTime: '10 min',
    gradient: 'from-amber-500 to-orange-500',
    content: [
      { type: 'p', text: 'SLA mal definido não melhora o atendimento — só cria pressão. Metas irreais viram números que ninguém respeita e, pior, minam a confiança do time. Este guia mostra como definir SLAs que puxam a operação para cima sem quebrá-la.' },
      { type: 'h2', text: '1. Meça antes de prometer' },
      { type: 'p', text: 'Antes de definir qualquer meta, entenda sua realidade atual: qual é hoje o seu tempo médio de primeira resposta e de resolução, por canal e por tipo de assunto? SLA se constrói a partir do dado, não do desejo.' },
      { type: 'h2', text: '2. Segmente por prioridade' },
      { type: 'ul', items: [
        'Crítico (serviço parado): resposta em minutos.',
        'Alto (impacta uso, mas há contorno): resposta em poucas horas.',
        'Normal (dúvidas e solicitações): resposta no mesmo dia útil.',
        'Baixo (sugestões, informações): próximo dia útil.',
      ] },
      { type: 'h2', text: '3. Diferencie primeira resposta de resolução' },
      { type: 'p', text: 'São dois SLAs distintos. O de primeira resposta mostra que você ouviu o cliente; o de resolução mostra que você entregou. Confundir os dois gera metas impossíveis e frustração.' },
      { type: 'quote', text: 'Um bom SLA é ambicioso o suficiente para importar e realista o suficiente para ser cumprido.' },
      { type: 'h2', text: '4. Automatize o acompanhamento' },
      { type: 'p', text: 'SLA controlado em planilha está fadado ao fracasso. Use alertas automáticos de risco de estouro, escalonamento por regra e roleta de tickets para distribuir a carga. No CoreDesk, cada ticket já nasce com o relógio de SLA rodando e avisa o time antes do prazo vencer.' },
      { type: 'h2', text: '5. Revise com o time, não contra ele' },
      { type: 'p', text: 'Traga os números para a reunião semanal como diagnóstico, não como cobrança. Quando o time participa da definição e entende o porquê de cada meta, o SLA deixa de ser ameaça e vira bússola.' },
    ],
  },
  {
    id: 5,
    slug: 'treinar-coreai-especialista-do-produto',
    category: 'IA',
    title: 'Como treinar seu CoreAI para virar um especialista do seu produto',
    excerpt: 'Boas práticas para criar uma base de conhecimento que faz sua IA responder como o seu melhor atendente.',
    author: 'Camila Torres',
    date: '3 semanas atrás',
    readTime: '7 min',
    gradient: 'from-rose-500 to-pink-500',
    content: [
      { type: 'p', text: 'Uma IA de atendimento é tão boa quanto o conhecimento que você dá a ela. A diferença entre um bot genérico e um especialista do seu produto está na qualidade e na organização da base de conhecimento. Veja como construir a sua.' },
      { type: 'h2', text: 'Comece pelas perguntas reais' },
      { type: 'p', text: 'Não invente o que a IA deveria saber — olhe o histórico. As perguntas que mais chegam ao seu time são exatamente o que a IA precisa dominar primeiro. Exporte os assuntos mais frequentes e transforme cada um em um artigo claro.' },
      { type: 'h2', text: 'Escreva para a máquina e para o humano' },
      { type: 'ul', items: [
        'Um assunto por artigo — evite textos que misturam vários temas.',
        'Título na forma de pergunta, como o cliente perguntaria.',
        'Respostas objetivas, com passos numerados quando fizer sentido.',
        'Inclua sinônimos e como o cliente costuma chamar cada coisa.',
      ] },
      { type: 'h2', text: 'Ensine também os limites' },
      { type: 'p', text: 'Tão importante quanto o que responder é o que não responder. Deixe claro para a IA quando ela deve transferir para um humano: cobranças, cancelamentos sensíveis, casos jurídicos. Um bom agente sabe a hora de pedir ajuda.' },
      { type: 'quote', text: 'IA não substitui documentação boa — ela expõe a documentação ruim que você já tinha.' },
      { type: 'h2', text: 'Melhore em ciclos' },
      { type: 'p', text: 'Treinamento não termina no dia do go-live. Revise semanalmente as conversas em que a IA errou ou transferiu sem necessidade, ajuste os artigos e observe a taxa de resolução subir. No CoreDesk, cada conversa vira insumo para deixar o CoreAI mais afiado.' },
    ],
  },
  {
    id: 6,
    slug: 'case-clinica-triplicou-agendamentos-coreai',
    category: 'Cases',
    title: 'Como uma clínica multiplicou por 3 os agendamentos com o CoreAI',
    excerpt: 'Estudo prático de implantação em clínica médica: desafios, aprendizados e resultados.',
    author: 'Bruno Lima',
    date: '1 mês atrás',
    readTime: '9 min',
    gradient: 'from-sky-500 to-blue-500',
    content: [
      { type: 'p', text: 'Uma clínica de médio porte perdia pacientes todos os dias por um motivo simples: ninguém conseguia responder a tempo. Veja como a operação foi reorganizada com o CoreAI e triplicou os agendamentos em três meses.' },
      { type: 'h2', text: 'O problema' },
      { type: 'p', text: 'A recepção acumulava as funções de atender o balcão, o telefone e o WhatsApp. Nos horários de pico, mensagens ficavam horas sem resposta — e paciente sem resposta rápida simplesmente marca em outro lugar. A taxa de mensagens não respondidas passava de 40%.' },
      { type: 'h2', text: 'A implementação' },
      { type: 'ul', items: [
        'CoreAI assumindo o primeiro contato 24/7, com respostas sobre convênios, valores e especialidades.',
        'Agendamento guiado dentro da conversa, integrado à agenda da clínica.',
        'Triagem automática: casos administrativos com a IA, casos clínicos direcionados à equipe.',
        'Lembretes automáticos para reduzir faltas (no-show).',
      ] },
      { type: 'h2', text: 'Os resultados em 90 dias' },
      { type: 'ul', items: [
        'Agendamentos via WhatsApp multiplicados por 3.',
        'Tempo de primeira resposta caiu de horas para segundos.',
        'Faltas reduzidas em 35% com os lembretes automáticos.',
        'Recepção liberada para cuidar melhor de quem está presente.',
      ] },
      { type: 'quote', text: '"Paramos de perder paciente por demora. A IA responde na hora e a equipe cuida do que importa." — Coordenação da clínica' },
      { type: 'h2', text: 'O aprendizado' },
      { type: 'p', text: 'A tecnologia resolveu, mas o ganho veio da combinação: IA no volume, gente no cuidado. Ao tirar o repetitivo das costas da recepção, a clínica não só agendou mais — melhorou a experiência de quem já era paciente. É esse equilíbrio que o CoreDesk foi feito para entregar.' },
    ],
  },
];
export const BLOG_CATEGORIES = ['Todos', 'IA', 'Atendimento', 'Vendas', 'Guias', 'Cases'];

// Help center
export const HELP_CATEGORIES = [
  { icon: 'Rocket', title: 'Começando', desc: 'Primeiros passos, criação de conta e configuração inicial.', count: 12 },
  { icon: 'MessageCircle', title: 'Conversas e canais', desc: 'WhatsApp, Instagram, e-mail, chat no site.', count: 24 },
  { icon: 'Sparkles', title: 'CoreAI', desc: 'Configuração do agente de IA e base de conhecimento.', count: 18 },
  { icon: 'Ticket', title: 'Helpdesk e tickets', desc: 'SLA, filas, distribuição e workflows.', count: 15 },
  { icon: 'Plug', title: 'Integrações', desc: 'Como conectar RD Station, Pipedrive, Shopify e outros.', count: 21 },
  { icon: 'CreditCard', title: 'Faturamento', desc: 'Planos, boletos, notas fiscais e upgrade.', count: 9 },
  { icon: 'BarChart3', title: 'Relatórios', desc: 'Métricas, dashboards e exportação de dados.', count: 11 },
  { icon: 'Shield', title: 'Segurança e LGPD', desc: 'Permissões, auditoria e conformidade.', count: 8 },
];
export const POPULAR_ARTICLES = [
  'Como criar meu primeiro chatbot em 10 minutos',
  'Configurando SLA por grupo de atendimento',
  'Treinando o CoreAI com sua base de conhecimento',
  'Integrando WhatsApp à minha conta CoreDesk',
  'Como exportar relatórios em CSV',
  'Convidando novos usuários e definindo permissões',
];

// Careers
export const JOBS = [
  { id: 1, title: 'Engenheiro(a) de Software Sênior', team: 'Engenharia', type: 'Remoto', location: 'Brasil', tags: ['React', 'Node.js', 'AWS'] },
  { id: 2, title: 'Product Designer', team: 'Produto', type: 'Remoto', location: 'Brasil', tags: ['Figma', 'Design System', 'B2B'] },
  { id: 3, title: 'Customer Success Manager', team: 'Sucesso do Cliente', type: 'Híbrido', location: 'São Paulo', tags: ['SaaS', 'B2B', 'Retenção'] },
  { id: 4, title: 'AI/ML Engineer', team: 'Engenharia', type: 'Remoto', location: 'Brasil', tags: ['Python', 'LLMs', 'RAG'] },
  { id: 5, title: 'Growth Marketing Analyst', team: 'Marketing', type: 'Remoto', location: 'Brasil', tags: ['Perfomance', 'SEO', 'B2B'] },
];
export const BENEFITS = [
  { icon: 'Home', title: 'Trabalho remoto' },
  { icon: 'Heart', title: 'Plano de saúde e odonto' },
  { icon: 'Gift', title: 'Auxílio home office' },
  { icon: 'GraduationCap', title: 'Auxílio educação' },
  { icon: 'Utensils', title: 'Vale alimentação e refeição' },
  { icon: 'Palmtree', title: 'Day off no aniversário' },
  { icon: 'Sparkles', title: 'Stock options' },
  { icon: 'Users', title: 'Cultura remote-first' },
];
